import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor, theme } from '@ezugi/ui/theme';

import { OPACITY_HIGH } from '../../../constants/colors';
import { PROGRESS_BAR, SECTION_HEADER_HEIGHT } from './constants';

export const GAME_BOARD_PERCENTAGE_HEIGHT = 24; // px

// background color for cards box on left side, and these boxes on desktop: statistics, disabled keypad, My Bets
export const lightBoxBgColor = {
  backgroundColor: getThemeColor('background', theme.tints.darkest),
};

export const lightBoxCSS = css(lightBoxBgColor);

export const SectionHeader = styled.header`
    height: ${SECTION_HEADER_HEIGHT}px;
    position: relative;
    color: ${getThemeColor('foreground')};
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
    line-height: 16px;
`;

export const Section = styled.section`
  height: 100%;
  top: 0;
  display: inline-flex;
  flex-flow: column nowrap;
  vertical-align: top;
  position: relative;
  transition: flex 0.27s linear, height 0.27s linear;
  transform-origin: bottom center;
  flex: 1;
  background: ${getThemeColor('primary')};

  > svg {
    overflow: visible;
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 23%;
  bottom: 0;
  left: 0;
  pointer-events: all;
  user-select: none;
  background: transparent;
  flex-flow: row nowrap;
  transform: translateY(0);
  transition: transform 0.2s linear;

  #bet-icon {
    pointer-events: all;
  }

  [id^='bet-'] {
    &:hover,
    &:active {
      cursor: pointer;
      .highlight {
        fill-opacity: ${OPACITY_HIGH};
      }
    }
  }
`;

export const inactiveGrid = css`
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.9;
`;

export const centerSectionClassName = css`
  align-items: center;
  flex-flow: column nowrap;
  flex: 1.9;
  border: 4px solid ${getThemeColor('primary')};
  border-radius: ${PROGRESS_BAR.BORDER_RADIUS}px ${PROGRESS_BAR.BORDER_RADIUS}px 0 0;
`;

export const mobileCenterSectionClassName = css`
  border: 0px;
  @media all and (orientation: landscape) {
    padding: 0 4px 2px 4px;
    flex: 1;
  }
  @media all and (orientation: portrait) {
    height: auto;
    flex-grow: 0;
    flex-basis: auto;
  }
`;

export const desktopBetGridClassName = css`
  padding: 0;
  height: 100%;
  width: 97%;
`;

export const progressBarClassName = css`
  height: ${PROGRESS_BAR.HEIGHT}px;
  width: 100%;
  border-radius: ${PROGRESS_BAR.BORDER_RADIUS}px;
`;

export const ProgressBarWrapper = styled.div`
  width: 100%;
`;

export const mobileContainerClassName = css`
  flex-flow: column nowrap;
  height: 315px;

  [data-name="center-section"] {
    background: transparent;
    order: 0;
  }
  [data-name="left-section"] {
    order: 1;
  }
  [data-name="right-section"] {
    order: 2;
  }

  @media all and (orientation: landscape) {
    padding: 0;
    height: auto;
  }
  @media all and (orientation: portrait) {
    background-color: ${getThemeColor('background')};
    padding: 0 4px;
  }
`;

export const mobileBetsClosedClassName = css`
  @media all and (orientation: landscape) {
    perspective: 400px;
    margin: 0;
    [data-name="center-section"] {
      transform: rotateX(55deg);
    }
  }
`;

export const smallSectionStyle = css`
  padding: 4px 4px 0 4px;
  height: calc(100% - ${SECTION_HEADER_HEIGHT}px);
  top: ${SECTION_HEADER_HEIGHT}px;
  ${lightBoxBgColor};
`;

export const mobileRightSection = css`
  @media all and (orientation: portrait) {
    height: auto;
    flex-grow: 0;
    flex-basis: auto;
  }
`;

export const mobileLeftSection = css`
  @media all and (orientation: portrait) {
    &:empty {
      display: none;
    }
  }
`;
